import { render, staticRenderFns } from "./CustomerEmailDiscount.vue?vue&type=template&id=738cf6a5&"
import script from "./CustomerEmailDiscount.vue?vue&type=script&lang=js&"
export * from "./CustomerEmailDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports